import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import TotalSummaryResult from "../models/TotalSummaryResult";

export interface GetTotalSummaryParam {
    year: number,
}

const TotalSummaryApi = {
    GetTotalSummary(param: GetTotalSummaryParam) {
        return Api.get<GetTotalSummaryParam, BaseResponse<TotalSummaryResult>>("/api/Fixture/GetTotalSummary", param);
    },
};
export default TotalSummaryApi;